import React, { Component } from 'react';
import { observer, inject } from 'mobx-react/native';

import { StyleSheet, View, FlatList } from 'react-native';
import SizeUtil from '../../../utils/SizeUtil';
import CityItem from './cityItem';
import { SelectCountryStoreModel } from '../../../stores/selectCountry/index';

const ROW_HEIGHT = 45;

/**
 * 城市列表SectionList页
 */

interface Props {
    searchResult: string[];
    onTextChange: (data: string) => void;
    toggleSearchPage: (status: boolean) => void;
}

@inject((store: SelectCountryStoreModel) => ({
    searchResult: store.searchBar.searchResult,
    onTextChange: store.searchBar.onTextChange,
    toggleSearchPage: store.searchBar.toggleSearchPage
}))
@observer
class IndexList extends Component<Props> {
    // row
    public renderItem = (item: any) => <CityItem info={item} />;

    public render() {
        const { searchResult } = this.props;
        return (
            <View style={styles.wrap}>
                <FlatList
                    data={searchResult}
                    keyExtractor={(item: any) => item.prenum}
                    keyboardShouldPersistTaps="handled"
                    renderItem={(item) => this.renderItem(item)}
                />
            </View>
        );
    }
}
export default IndexList;

const styles = StyleSheet.create({
    wrap: {
        zIndex: 99,
        position: 'absolute',
        top: 0,
        left: 0,
        bottom: 0,
        right: 0,
        backgroundColor: 'rgba(33,33,33,0.4)'
    },
    rowStyle: {
        backgroundColor: '#fff',
        paddingLeft: SizeUtil.getSize(11),
        paddingRight: SizeUtil.getSize(11),
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
        borderBottomWidth: StyleSheet.hairlineWidth,
        borderBottomColor: '#eee',
        height: ROW_HEIGHT
    }
});
